<template>
  <!-- 红包管理-红包配置-新建/编辑红包弹窗 -->
  <div>
    <el-dialog
      :title="dialogInfo === 0 ? '添加红包' : '编辑红包'"
      :close-on-click-modal="false"
      :visible.sync="showMark"
      width="450px"
      center
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        ref="formData"
        label-width="90px"
        :rules="addrules"
        size="small"
      >
        <el-form-item prop="name" label="红包名称">
          <el-input
            v-model="formData.name"
            placeholder="请输入红包名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="des" label="红包规则">
          <el-input
            type="textarea"
            :rows="10"
            v-model="formData.des"
            placeholder="请输入红包规则"
          ></el-input>
        </el-form-item>
        <el-form-item prop="type" label="红包类型">
          <el-select v-model="formData.type">
            <el-option label="每日红包" :value="1"></el-option>
            <el-option label="累充红包" :value="2"></el-option>
            <el-option label="其他红包" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="红包状态">
          <el-select v-model="formData.status">
            <el-option label="期待中" :value="1"></el-option>
            <el-option label="进行中" :value="2"></el-option>
            <el-option label="已结束" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="weight" label="红包权重">
          <el-input
            v-model="formData.weight"
            placeholder="请输入红包权重"
          ></el-input>
        </el-form-item>
        <el-form-item prop="display" label="红包显示">
          <el-select v-model="formData.display">
            <el-option label="显示" :value="1"></el-option>
            <el-option label="隐藏" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submit"
            :loading="buttonLoading"
            style="margin-left: 50px"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { api, server, getData, getApiData, postApiData, patchApiData } from '@/http'

import ImgUpload from '@/components/common/ImgUpload'//上传图片组件


export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//传来的数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      dialogType: 0,//弹窗类型，0为添加红包，1为编辑红包
      loading: false,//加载动画
      buttonLoading: false,//加载按钮动画
      query: {
      },
      formData: {//表单数据
        name: '',//红包名称
        des: '',//红包规则
        type: undefined,//红包类型
        status: undefined,//红包状态 1期待中 2进行中 3已结束
        display: undefined,//红包是否显示  1是隐藏 2是显示
        weight: undefined,//红包权重
      },
      addrules: {//添加表单校验规则
        name: [{ required: true, message: '请输入红包名称' }],
        des: [{ required: true, message: '请输入红包规则' }],
        type: [{ required: true, message: '请选择红包类型' }],
        status: [{ required: true, message: '请选择红包状态' }],
        weight: [{ required: true, message: '请输入红包权重' }],
        display: [{ required: true, message: '请选择红包是否展示' }]
      },
    }
  },
  computed: {
    ...mapState({
    }),
    showMark: {
      get() {
        return this.visible
      },
      set(bool) {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set(bool) {
      }
    }
  },
  watch: {
    showMark(val) {
      if (val) {
        if (this.dialogInfo) {
          //编辑
          this.dialogType = 1
          this.formData = this.dialogInfo
        } else {
          // 添加
          this.dialogType = 0
          this.formData = {//表单数据
            name: '',//红包名称
            des: '',//红包规则
            type: undefined,//红包类型
            status: undefined,//红包状态
            display: undefined,//红包是否显示  0是不显示 1是显示
          }
        }
      }
    }
  },
  created() {
  },
  mounted() { },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    submit() {
      //提交表单信息
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData
          if (this.dialogType === 0) {
            //添加
            postApiData('red_envelope', params).then(res => {
              if (res) {
                this.$message.success(res.msg)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新列表
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          } else if (this.dialogType === 1) {
            //编辑
            patchApiData(`red_envelope/${this.dialogInfo.id}`, params).then(res => {
              if (res) {
                this.$message.success(res.msg)
                this.closeDialog()//关闭弹窗
                this.$emit("refresh")//刷新列表
              }
            }).finally(() => {
              this.buttonLoading = false
            })
          }
        }
      })

    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>